/** Convert a #RRGGBB (or #RGB) hex string to an rgba() string at the given alpha. */
export function hexToRgba(hex: string, alpha: number): string {
    let h = hex.replace('#', '')
    if (h.length === 3) {
        h = h
            .split('')
            .map(c => c + c)
            .join('')
    }
    const r = parseInt(h.slice(0, 2), 16)
    const g = parseInt(h.slice(2, 4), 16)
    const b = parseInt(h.slice(4, 6), 16)
    if ([r, g, b].some(n => Number.isNaN(n))) return hex
    return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

/** Semantic status tones → theme token pairs (soft background + solid foreground). */
export const tonePairs = {
    ok: { bg: '$statusOkSoft', fg: '$statusOk' },
    warn: { bg: '$statusWarnSoft', fg: '$statusWarn' },
    danger: { bg: '$statusDangerSoft', fg: '$statusDanger' },
    info: { bg: '$statusInfoSoft', fg: '$statusInfo' },
    violet: { bg: '$statusVioletSoft', fg: '$statusViolet' },
    accent: { bg: '$accentSoft', fg: '$accentText' },
    neutral: { bg: '$statusNeutralSoft', fg: '$colorSoft' },
} as const

export type BadgeTone = keyof typeof tonePairs

/**
 * File-extension colours for the Files tab ext-pills (identical in both themes).
 */
export const fileExtColors: Record<string, string> = {
    pdf: '#E85959',
    doc: '#4F9BF0',
    docx: '#4F9BF0',
    xls: '#2DBA78',
    xlsx: '#2DBA78',
    csv: '#2DBA78',
    jpg: '#1FB2A6',
    jpeg: '#1FB2A6',
    png: '#1FB2A6',
    gif: '#1FB2A6',
    webp: '#1FB2A6',
    zip: '#DD9B34',
    rar: '#DD9B34',
    eml: '#A47EF0',
    msg: '#A47EF0',
}

export const fileExtFallbackColor = '#7C8290'

export function colorForExt(ext: string | undefined): string {
    if (!ext) return fileExtFallbackColor
    return fileExtColors[ext.toLowerCase().replace('.', '')] ?? fileExtFallbackColor
}
